import React from 'react';
import { connect } from 'react-redux';
import SecurityPassword from './SecurityPassword.js';
import { actions } from './SecurityPassword.actions';

const SecurityPasswordComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            changePassword: actions.changePassword
        };
    }
)(SecurityPassword);

export default SecurityPasswordComponent;
